import Image from 'components/shared/image/image';
import RichText from 'components/shared/richtext';
import useIsMobile from 'hooks/utils/useIsMobile';
import cn from 'classnames';
import styles from './contact.module.scss';

const ContactInfo = ({ data, showHeader = false, hideContact = false, id }) => {
  const {
    title,
    subtitle,
    heroImage,
    infoTitle,
    infoBody,
    consumerTitle,
    consumerPhone,
    salonsTitle,
    salonsPhone,
    salonsEmail,
    addressTitle,
    addressText,
    secondaryImage,
    email,
  } = data;
  const trimPhoneNumber = string => string?.match(/(\d[\s\S]*)/)?.[1]?.trim();

  const isMobile = useIsMobile();
  const strippedConsumerPhone = consumerPhone ? `+${trimPhoneNumber(consumerPhone)}` : '';
  const strippedAddressPhone = salonsPhone ? `+${trimPhoneNumber(salonsPhone)}` : '';

  return (
    <section
      id={id}
      className={cn({
        [styles.hidden]: hideContact,
      })}
    >
      <section className={styles.section}>
        {showHeader && (
          <div className={styles.contactHeader}>
            <h1 className={styles.title}>{title}</h1>
            <h3 className={styles.subtitle}>{subtitle}</h3>
          </div>
        )}
        <div className={styles.customerSupport}>
          <div className={styles.heroImage}>
            <Image src={heroImage} layout="fill" loading="lazy" />
          </div>
          <div className={styles.customerSection}>
            {infoTitle && <h2 className={styles.infoTitle}>{infoTitle}</h2>}
            {infoBody && <RichText className={styles.infoBody} text={infoBody.json} />}
            {consumerTitle && <h2 className={styles.consumerTitle}>{consumerTitle}</h2>}
            {consumerPhone && (
              <a
                href={`tel:${strippedConsumerPhone}`}
                aria-label={`${consumerTitle}: ${consumerPhone}`}
                className={styles.consumerPhone}
              >
                {consumerPhone}
              </a>
            )}
            {isMobile && (
              <span className={styles.consumerEmail}>
                {email}
                <a href={`mailto: ${salonsEmail}`} className={styles.email}>
                  {salonsEmail}
                </a>
              </span>
            )}
            {salonsTitle && <h2 className={styles.salonsTitle}>{salonsTitle}</h2>}
            {salonsPhone && (
              <a
                href={`tel:${strippedAddressPhone}`}
                aria-label={`${salonsTitle}: ${salonsPhone}`}
                className={styles.salonsPhone}
              >
                {salonsPhone}
              </a>
            )}
            {isMobile && (
              <span className={styles.salonsEmail}>
                {email}
                <a href={`mailto: ${salonsEmail}`} className={styles.email}>
                  {salonsEmail}
                </a>
              </span>
            )}
          </div>
        </div>
      </section>
      <section className={styles.headQuartersSection}>
        <div className={styles.secondImage}>
          <Image src={secondaryImage} layout="fill" loading="lazy" />
        </div>
        <div className={styles.headQuarterInfo}>
          {addressTitle && <h2 className={styles.addressTitle}>{addressTitle}</h2>}
          <RichText className={styles.addressInfo} text={addressText?.json} />
          <div className={styles.socials}>
            {salonsPhone && (
              <a
                href={`tel:${strippedAddressPhone}`}
                aria-label={`${addressTitle}: ${salonsPhone}`}
                className={styles.addressPhone}
              >
                {salonsPhone}
              </a>
            )}
            <span className={styles.addressEmail}>
              {email}
              <a href={`mailto: ${salonsEmail}`} className={styles.email}>
                {salonsEmail}
              </a>
            </span>
          </div>
        </div>
      </section>
    </section>
  );
};

export default ContactInfo;
